import initialMetricsPublisher from "src/metrics";
import MetricsUtil from "./MetricsUtil";
import {makeMetricsDriver} from "src/metrics";

const METRICS_PREFIX = 'RevCal';
const driver = makeMetricsDriver()
export default new MetricsUtil(driver, initialMetricsPublisher, METRICS_PREFIX)